//@flow
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/pt-br';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import Anamnese from './Anamnese';

type State = {
  anamnese: any,
  // newAnamnese: boolean,
};

// const defaultEntity: anamnese = {
//   id: 0,
//   anamnese: '',
//   fkUsuario: 0,
//   listMidiaVO: [],
//   pacienteVO: Object,
//   receituarioVO: Object,
// };

class AnamnesView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    console.log(this.props.location ? this.props.location.state.anamnese:{});
    this.state = {
      anamnese: this.props.location ? this.props.location.state.anamnese : {},
      // newAnamnese: false,
      entity: { paciente: {} },
      paciente: this.props.location
        ? this.props.location.state.anamnese.paciente
        : {},
    };
  }

  handleSave = (values) => {
    let _newEnntity = _.cloneDeep(this.state.entity);
    _newEnntity = values;
    this.setState({ entity: _newEnntity });
  };

  render() {
    const { entity, paciente, anamnese } = this.state;
    return (
      <div className="prontuario-page">
        <TopoTitleComponente
          mainTitle={_.get(paciente, 'nome')}
          canBack={true}
          // backConfirmObject={   }
        />
        <Anamnese
          key={anamnese.id}
          entity={anamnese}
          viewMode={true}
          showAvatar={true}
          data={moment(anamnese.dataCadastro).toDate()}
        />
      </div>
    );
  }
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(
  mapStateToProps,
  mapDispatch,
  null
)(withRouter(AnamnesView));


